(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-buy-now]');
    if (!btn || btn.disabled) return;

    var form = btn.closest('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    var variantId = idInput && idInput.value ? idInput.value : btn.getAttribute('data-variant-id');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Se procesează...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error((data && data.description) || 'Nu am putut adăuga produsul în coș.');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = originalText;
        alert(err && err.message ? err.message : 'A apărut o eroare. Încercați din nou.');
      });
  });
})();
